<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes=" table-responsive">
            <template slot="header">
              <div class="row">
                  <div class="col-6">
                      <h4 class="card-title"><i class="icon-svg icon-user"></i>{{$t('Usuarios')}}</h4>
                  </div>
                   <!--<div class="col-6 d-flex justify-content-end">
                       <router-link to="user" class="btn bg-dark text-white font-weight-bold py-2 ">
                           <i class="fas fa-plus"></i>
                           <span class="font-weight-bold px-2">
                                {{$t("Agregar")}}
                            </span> 
                       </router-link>
                  </div>-->
              </div>
            </template>
            <l-table class="pl-4 table-hover table-striped"
                     :columns="table.columns"
                     :section="section"
                     :data="tableData"
                     :can-delete="canDeleteUser"
                     @deleteEvent="onDeleteEvent">
            </l-table>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { apiCallList, dataTableLengthMenu, dataTableEsLanguage, enhanceDataTableLength } from '../../mixins'

  export default {
    mixins: [apiCallList],
    components: {

    },
    computed : {
      ...mapGetters({
        loggedUser : 'login/user'
      })
    },
    data () {
      return {
        endpoint : "user",
        section  : "user",
        tableData : [],
        table: {
          columns: ['Id', 'name', 'Email','Rol','Company','actions'],
        }
      }
    },
    methods : {
        loadItems(){
            this.data.forEach((item) => {
              item.rol = item.roles ? item.roles.name : "";
              // The company of a user is the contact it belongs to (relation 'client',
              // through user_client). An administrator has none, so the cell stays empty.
              item.company = item.client
                  ? (item.client.lastname ? item.client.name + ' ' + item.client.lastname : item.client.name)
                  : "";
            });
            this.tableData = this.data;
            setTimeout(() => {
              window.$(".table").dataTable({
                pageLength: 10,
                lengthMenu: dataTableLengthMenu,
                language: dataTableEsLanguage,
                autoWidth: false,
                columnDefs: [{ orderable: false, targets: -1 }]
              });
              enhanceDataTableLength();
            },100);
        },
        // A logged in user must never be able to delete their own account: it
        // would log them out of an account that no longer exists and, when
        // they are the only administrator, leave the company without one.
        canDeleteUser(item){
          return !this.loggedUser || item.id != this.loggedUser.id;
        },
        onDeleteEvent(item){
          if (!this.canDeleteUser (item)) return;
          this.$dialog.confirm({
            title: this.$t("Eliminar"),
            body: this.$t("EliminarContactoText"),
            okText: this.$t("Eliminar"),
            cancelText: this.$t("Cancelar"),
          },
          { customClass: 'cd-dialog cd-dialog--danger' }).then(() => {
            this.$axios.delete("/user/" + item.id).then(() => {
              this.fetch();
            });
          });
        }
    }
  }
</script>
<style>
</style>